import { RSAA } from 'redux-api-middleware'

import { types, initialState } from './index'
import { contentfulEndpoint, getContentfulProxyHeaders } from './utils'

/**
 * Generic action to fetch contentful data that requires a graphql query Meta
 * object is optional, only needed for care search contenful calls
 *
 * @param {String} query The graphql query, should be passed in to the endpoint
 *   from the the component thats calling this action
 */
export const fetchArticleSlugs = query => {
  return {
    [RSAA]: {
      endpoint: contentfulEndpoint,
      method: 'POST',
      headers: getContentfulProxyHeaders(),
      body: JSON.stringify({ query }),
      types: [
        types.FETCH_ARTICLE_SLUGS_REQUEST,
        types.FETCH_ARTICLE_SLUGS_SUCCESS,
        types.FETCH_ARTICLE_SLUGS_ERROR,
      ],
      cache: true,
    },
  }
}

export const clearArticleSlugs = () => ({
  type: types.CLEAR_ARTICLE_SLUGS,
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_ARTICLE_SLUGS_REQUEST: {
      return {
        ...state,
        slugs: {
          ...state.slugs,
          busy: true,
          error: null,
        },
      }
    }

    case types.FETCH_ARTICLE_SLUGS_SUCCESS: {
      const { data } = payload
      return {
        ...state,
        slugs: {
          ...state.slugs,
          busy: false,
          entities: data,
        },
      }
    }

    case types.FETCH_ARTICLE_SLUGS_ERROR: {
      return {
        ...state,
        slugs: {
          ...state.slugs,
          busy: false,
          error: payload,
        },
      }
    }

    case types.CLEAR_ARTICLE_SLUGS: {
      return {
        ...state,
        slugs: {
          ...state.slugs,
          entities: initialState.slugs.entities,
        },
      }
    }

    default:
      return state
  }
}
